// extracted by mini-css-extract-plugin
module.exports = {"linkRibbonContainer":"link-ribbons-module--link-ribbon-container--2UN1B","linkStyledContainer":"link-ribbons-module--link-styled-container--1qIfO"};